import React from "react";
import Section from "./Section";

import {
  Flex,
  Paragraph,
  Heading,
  Separator,
  Button,
  IconButton,
  Avatar,
  Loader,
} from "../src/index";
import ReactLive from "./ReactLive";
import {
  Cross2Icon,
  SizeIcon,
  CopyIcon,
  BellIcon,
} from "sebikostudio-icons";
import Beaver from "../assets/avatar.png";
import CodeFormatter from "./CodeFormatter";

const LoaderPage = () => {
  const codeString1 = `  
import { Loader } from "blocksin-system";

<Loader />
            `;
  const scope = {
    Separator,
    Avatar,
    Beaver,
    Button,
    Cross2Icon,
    SizeIcon,
    CopyIcon,
    IconButton,
    Flex,
    Heading,
    BellIcon,
    Paragraph,
    Loader,
  };

  //
  return (
    <>
      <Flex direction={"column"} id="IconButton" className={"WebPageBody"}>
        <Section>
          <Heading level={2} weight="bold">
            Loader Component
          </Heading>
          <Paragraph size="large">
            The Loader component is a React component that displays an animated
            loading indicator. It uses lottie-react to render a smooth and
            visually appealing animation, making it ideal for indicating loading
            states or processing actions in your application.
          </Paragraph>
          <Flex className="ComponentPreview">
            <Loader />
          </Flex>
          <Heading level={3} weight="bold">
            Usage
          </Heading>
          <CodeFormatter language="" codeString={codeString1} />
        </Section>

        <Section>
          <Heading level={3} weight="bold">
            Playground
          </Heading>
          <Paragraph size="large">
            Experience real-time component interaction with React! This powerful
            feature empowers non-technical users—designers, project managers,
            brand or content specialists—to seamlessly engage with components.
            They can modify component content on the fly, ensuring comprehensive
            validation against accessibility, localization, and content design
            requirements. This hands-on approach ensures the design aligns
            perfectly with all necessary criteria, fostering a more
            collaborative and efficient development process.
          </Paragraph>

          <ReactLive scope={scope}>
            {`
<Flex direction="row" gap={100}
  style={{
    position: "relative",
    width: "100%",
    height: "100%",
  }}
>
  <Loader />
</Flex>
      `}
          </ReactLive>
        </Section>
      </Flex>
    </>
  );
};

export default LoaderPage;
